<template>
    <!-- <ValidationErrors :show="showErrors"/> -->
    <Head :title="'Invoices - ' + project.title"/>
    <div class="w-full mb-6">
        <ProjectHeader :project="project"></ProjectHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div v-if="invoices.length == 0" class="rounded-md bg-blue-50 p-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <InformationCircleIcon class="h-5 w-5 text-blue-400"
                                                                aria-hidden="true"/>
                                    </div>
                                    <div class="ml-3 space-y-3">
                                        <p class="text-sm text-blue-700">No invoices have been raised for this project.</p>
                                        <p class="text-sm text-blue-700">To raise an invoice, click on the <span class="underline"><Link :href="'quotes'">quotes</Link></span> tab and select the quote you wish to raise an invoice against.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Invoices</h3>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" v-if="quotes.length > 0" v-for="(quote, index) in quotes" :key="index">
                                <div class="flex pl-5 ml-3 pb-5 border-b border-gray-200 justify-between items-center">
                                    <h4 class="text-lg leading-6 font-bold text-gray-900">{{ quote.client.name }} - {{ quote.name }}</h4>
                                </div>
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <InvoiceList :invoices="quote.invoices" :project="project" :display_related_quotes="false"/>
                                    </div>
                                </div>
                            </div>
                            <div v-if="commission_grouped.length > 0" v-for="(commission_invoices, index) in commission_grouped" :key="index">
                                <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Commission Financial transactions with {{ commission_invoices.organisation.name }}</h3>
                                </div>

                                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                            <InvoiceList :invoices="commission_invoices.invoices" :project="project" :display_related_quotes="false" invoice_type="Commission"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </section>
        </div>
    </div>
    <LinkInvoiceToSupplierInvoice/>

</template>


<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head} from "@inertiajs/vue3";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import ProjectHeader from "@/Components/ProjectHeader";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import Button from "@/Components/Button.vue";

import DuplicateQuote from "@/Components/SlideOuts/DuplicateQuote";
import InvoiceList from "@/Components/InvoiceList.vue";
import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";

export default {
    layout: Authenticated,
    components: {
        LinkInvoiceToSupplierInvoice,
        DuplicateQuote,
        Button,
        CreateQuote,
        ProjectHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        InvoiceList
    },
    props: {
        project: Object,
        invoices: Object,
        quotes: Object,
        commission_grouped: Object,
    }
}
</script>
